export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Cn-7498adfca5fd9653f7e7e569ec0158d5.woff2";